import _pick from 'lodash/pick';
import _functions from 'lodash/functions';
import { getYear } from 'date-fns';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Svg from 'rp-react-svg-icon';
import ProfilesForm from './components/ProfilesForm';
import ProfilesTypesList from './components/ProfilesTypesList';
import ProfilesList from './components/ProfilesList';
import * as actions from './profiles.actions';
import { profilesTypes, isHorseProfiles } from './profiles.utils';

/**
 * Profiles tab presentational component
 */
export class Profiles extends PureComponent {
    static propTypes = {
        /**
         * Data from the search form
         */
        search: PropTypes.shape({
            /**
             * User search query
             */
            query: PropTypes.string.isRequired,
            /**
             * User search profiles type
             */
            profilesType: PropTypes.string.isRequired,
        }).isRequired,
        /**
         * Properties to render profiles types (when no type selected)
         */
        profilesTypes: PropTypes.shape({
            /**
             * True while application is fetching profiles types from server
             */
            fetching: PropTypes.bool.isRequired,
            /**
             * True if last profiles types fetching has failed
             */
            fetchFailed: PropTypes.bool.isRequired,
            /**
             * Array of fetched profiles types
             */
            items: PropTypes.arrayOf(PropTypes.object).isRequired,
            /**
             * Overall number of available profiles types
             */
            itemsNum: PropTypes.number.isRequired,
        }).isRequired,
        /**
         * Properties to render profiles (when profiles type selected)
         */
        profiles: PropTypes.shape({
            /**
             * True if application is fetching profiles from server
             */
            fetching: PropTypes.bool.isRequired,
            /**
             * True if last profiles fetch has failed
             */
            fetchFailed: PropTypes.bool.isRequired,
            /**
             * Current profiles page
             */
            page: PropTypes.number.isRequired,
            /**
             * Overall number of available profiles pages
             */
            pagesNum: PropTypes.number.isRequired,
            /**
             * Array of fetched profiles
             */
            items: PropTypes.arrayOf(PropTypes.object).isRequired,
            /**
             * Overall number of available profiles
             */
            itemsNum: PropTypes.number.isRequired,
        }).isRequired,
        /**
         * Function to get profiles from server
         */
        fetchProfiles: PropTypes.func.isRequired,
        /**
         * Function to get profiles types from server
         */
        fetchProfilesTypes: PropTypes.func.isRequired,
        /**
         * Function to apply search (for search form)
         */
        changeSearch: PropTypes.func.isRequired,
        /**
         * Function to select page (for pagination)
         */
        changePage: PropTypes.func.isRequired,
    }

    static renderHorseProfileItem(item, i) {
        return (
            <li
                key={i}
                className="search-resultList__item"
            >
                <a
                    className="search-resultList__link js-popupLink"
                    href={item.url}
                >
                    <span className="search-resultList__linkName ui-link ui-link_table">
                        {item.profiles_name}
                        <Svg
                            iconName="right"
                            size="Small"
                        />
                    </span>
                    <span className="search-resultList__linkCountry">
                        {item.profiles_country_code}
                    </span>
                    &nbsp;
                    <span className="search-resultList__linkYear">
                        {item.profiles_year
                            ? getYear(item.profiles_year.replace(/[^\d]/g, ''))
                            : ''
                        }
                    </span>

                </a>
            </li>
        );
    }

    static renderProfileItem(item, i) {
        return (
            <li
                key={i}
                className="search-resultList__item"
            >
                <a
                    className="search-resultList__link js-popupLink ui-link ui-link_table"
                    href={item.url}
                >
                    <span className="search-resultList__linkName">
                        {item.title}
                        <Svg
                            iconName="right"
                            size="Small"
                        />
                    </span>
                </a>
            </li>
        );
    }

    componentDidMount() {
        this.fetch();
    }

    componentWillReceiveProps({
        search: { query, profilesType },
        profiles: { page },
    }) {
        if (
            this.props.search.query !== query
            || this.props.search.profilesType !== profilesType
            || this.props.profiles.page !== page
        ) {
            this.fetch(profilesType);
        }
    }

    fetch(profilesType = this.props.search.profilesType) {
        if (!profilesType) {
            this.props.fetchProfilesTypes();
        } else {
            this.props.fetchProfiles();
        }
    }

    handleFormSubmit = search => this.props.changeSearch(search);
    handleProfilesTypeChange = (profilesType = '') => {
        this.props.changeSearch({ profilesType });
    }

    render() {
        const { search, profiles, changePage } = this.props;
        return (
            <div className="search-tab__profile">
                <ProfilesForm
                    {...search}
                    profilesTypes={[{ value: '', label: 'All' }].concat(
                        Object.keys(profilesTypes).map(key => ({
                            value: key,
                            label: profilesTypes[key],
                        })),
                    )}
                    onSubmit={this.handleFormSubmit}
                />
                {search.profilesType
                    ? (<ProfilesList
                        title={profilesTypes[search.profilesType]}
                        {...profiles}
                        itemRenderer={isHorseProfiles(search.profilesType)
                        ? Profiles.renderHorseProfileItem
                        : Profiles.renderProfileItem
                    }
                        onGoBack={this.handleProfilesTypeChange}
                        onPageChange={changePage}
                    />)
                    : (<ProfilesTypesList
                        {...this.props.profilesTypes}
                        onSelect={this.handleProfilesTypeChange}
                    />)
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state.profiles;
}

/**
 * Profiles tab container component
 */
export default connect(mapStateToProps, _pick(actions, _functions(actions)))(Profiles);



// WEBPACK FOOTER //
// ./src/js/Profiles/Profiles.jsx